import { Button } from '@seen/ui'
import { IconX } from '@tabler/icons-react'
import type { JSX } from 'react'
import { Dialog } from '#src/components/core/dialog/Dialog.tsx'
import { DialogClose } from '#src/components/core/dialog/DialogClose.tsx'
import { DialogDisplay } from '#src/components/core/dialog/display/DialogDisplay.tsx'
import { useHotkeys } from '#src/hooks/useHotkeys.ts'

interface AttachmentPDFModalProps {
  url: string
  title?: string
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function AttachmentPDFModal({
  url,
  title,
  open,
  onOpenChange,
}: AttachmentPDFModalProps): JSX.Element {
  useHotkeys('Escape', () => onOpenChange(false))

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogDisplay
        className="fixed inset-8 z-10000 m-0! mt-0! h-[calc(100vh-4rem)]! max-h-none! w-[calc(100vw-4rem)]! max-w-none! rounded-lg border-0 bg-black/95 p-0!"
        hideCloseButton
        notScrollable
      >
        <DialogClose asChild>
          <Button
            variant="ghost"
            size="icon"
            className="fixed top-2 right-2 z-10001 text-white hover:bg-white/20"
          >
            <IconX className="h-6 w-6" />
          </Button>
        </DialogClose>
        <iframe
          src={`${url}#navpanes=0`}
          className="h-full w-full rounded-lg"
          allowFullScreen
          title={title || 'PDF Document'}
        />
      </DialogDisplay>
    </Dialog>
  )
}
